import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Box, CircularProgress, Typography } from "@mui/material";

function GoogleCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token  = params.get("token");
    const user   = params.get("user");
    const error  = params.get("error");

    if (error) {
      const messages = {
        google_failed  : "Login Google gagal. Coba lagi.",
        inactive       : "Akun Anda tidak aktif. Hubungi administrator.",
        role_not_found : "Terjadi kesalahan. Hubungi administrator.",
      };
      navigate("/login?error=" + encodeURIComponent(messages[error] ?? "Login gagal."));
      return;
    }

    if (token && user) {
      try {
        const parsedUser = JSON.parse(decodeURIComponent(user));
        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(parsedUser));

        // Kalau belum punya password → paksa buat password dulu
        if (!parsedUser.has_password) {
          navigate("/create-password");
        } else {
          const role = parsedUser.role?.name;
          if (role === "superadmin") {
            navigate("/superadmin");
          } else if (role === "admin") {
            navigate("/admin");
          } else {
            navigate("/");
          }
        }
      } catch {
        navigate("/login?error=" + encodeURIComponent("Login gagal. Coba lagi."));
      }
    } else {
      navigate("/login?error=" + encodeURIComponent("Login gagal. Coba lagi."));
    }
  }, [navigate]);

  return (
    <Box sx={{
      minHeight: "100vh", display: "flex", flexDirection: "column",
      alignItems: "center", justifyContent: "center", gap: 2,
    }}>
      <CircularProgress size={32} sx={{ color: "#111827" }} />
      <Typography sx={{ fontSize: "0.9rem", color: "#6b7280" }}>
        Memproses login Google...
      </Typography>
    </Box>
  );
}

export default GoogleCallback;